export const FONTS = {
    ACCENT: 'Roboto Black',
    REGULAR: 'Roboto'
};
